import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import UserProfileSidebar from '../components/user_profile/UserProfileSidebar';
import UserProfileContent from '../components/user_profile/UserProfileContent';
import MyOrders from '../components/user_profile/MyOrders';
import Addresses from '../components/user_profile/Addresses';
import Settings from '../components/user_profile/Settings';
import Wishlist from '../components/user_profile/Wishlist';


import { useSelector } from 'react-redux';
import { mustCompleteProfileBeforeBrowsing, isMandatoryProfileGateRole } from '../utils/profileCompletion';
// import { Settings } from 'lucide-react';

const UserProfilePage = () => {
    const user = useSelector(state => state.user);
    const loggedIn = useSelector(state => state.auth.loggedIn);
    const location = useLocation();
    const [activeSection, setActiveSection] = useState('profile');

    const profileCompletionLocked = mustCompleteProfileBeforeBrowsing(loggedIn, user);
    const showMyOrdersNav = isMandatoryProfileGateRole(user);

    useEffect(() => {
        if (profileCompletionLocked) {
            setActiveSection('profile');
            return;
        }
        if (location.state?.activeSection === 'addresses') {
            setActiveSection('addresses');
        }
    }, [location.state, profileCompletionLocked]);

    useEffect(() => {
        if (!showMyOrdersNav && activeSection === 'orders') {
            setActiveSection('profile');
        }
    }, [showMyOrdersNav, activeSection]);

    return (
        <div className="main-container">
            <UserProfileSidebar
                user={{
                    name: user.fullName || `${user.firstName} ${user.lastName}`.trim(),
                    email: user.email
                }}
                activeSection={activeSection}
                onSectionChange={setActiveSection}
                profileCompletionLocked={profileCompletionLocked}
                showMyOrdersNav={showMyOrdersNav}
            />
            {activeSection === 'profile' && (
                <UserProfileContent profileCompletionLocked={profileCompletionLocked} />
            )}
            {showMyOrdersNav && activeSection === 'orders' && <MyOrders />}
            {activeSection === 'addresses' && <Addresses />}
            {activeSection === 'settings' && <Settings />}
            {activeSection === 'wishlist' && <Wishlist />}
            {/* Add more sections as needed */}
        </div>
    );
};

export default UserProfilePage;
